function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _get from 'lodash/get';
import _each from 'lodash/each';
var STATE_DEFAULT = {};
export var GENERATORS_SELECTED_UPDATE = 'GENERATORS_SELECTED_UPDATE';
export var GENERATORS_SELECTED_CLEAR = 'GENERATORS_SELECTED_CLEAR';
export var GENERATORS_UPDATE = 'GENERATORS_UPDATE';
export var GENERATOR_DATA_CLEAR = 'GENERATOR_DATA_CLEAR';
export default function graphGeneratorData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var generatorMap = {};

  switch (action.type) {
    case GENERATORS_SELECTED_UPDATE:
      generatorMap = Object.assign({}, state[action.graphId]);
      generatorMap[action.generatorId].selected = !!action.selected;
      return Object.assign({}, state, _defineProperty({}, action.graphId, generatorMap));

    case GENERATORS_UPDATE:
      action.generators.forEach(function (generator) {
        generatorMap[generator.id] = Object.assign({
          selected: _get(state[action.graphId], "".concat(generator.id, ".selected"), !!generator.parent)
        }, generator); // Don't include selected in the passed generators
      });
      return Object.assign({}, state, _defineProperty({}, action.graphId, generatorMap));

    case GENERATORS_SELECTED_CLEAR:
      generatorMap = Object.assign({}, state[action.graphId]);

      _each(generatorMap, function (generator) {
        generatorMap[generator.id] = Object.assign({}, generatorMap[generator.id], {
          selected: false
        });
      });

      return Object.assign({}, state, _defineProperty({}, action.graphId, generatorMap));

    case GENERATOR_DATA_CLEAR:
      return Object.assign({}, STATE_DEFAULT);

    default:
      return state;
  }
}